import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import html2canvas from 'html2canvas';

@Component({
    selector: 'app-payment-success-dialog',
    templateUrl: './payment-success-dialog.component.html',
    styleUrls: ['./payment-success-dialog.component.styl']
})
export class PaymentSuccessDialogComponent implements OnInit {
    constructor(private dialogRef: MatDialogRef<PaymentSuccessDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        console.log(this.data);
    }

    close() {
        this.dialogRef.close();
    }

    save(receipt, downloadButton) {
        html2canvas(receipt, {}).then(canvas => {
            const image = canvas.toDataURL('image/png')
                .replace('image/png', 'image/octet-stream');
            downloadButton.setAttribute('href', image);
            downloadButton.click();
        });
    }
}
